import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import FormRequest from '../common/formRequest';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { alvaraFormEnum } from 'src/app/Enums/SpecificFormInputEnum';
import { EnderecoFormComponent } from 'src/app/components/endereco-form/endereco-form.component';
import { GenericValidator } from '../utilities/genericValidator';
import { UserDataRequestService } from 'src/app/app-core/services/user-data-request.service';
import { CnaeService } from 'src/app/app-core/services/cnae.service';

@Component({
    selector: 'app-form-request-alvara',
    templateUrl: './form-request-alvara.component.html',
    styleUrls: ['./form-request-alvara.component.scss']
})
export class FormRequestAlvaraComponent extends FormRequest implements OnInit, OnChanges {

    @ViewChild(EnderecoFormComponent) enderecoFormComponent: EnderecoFormComponent;
    @ViewChild('enderecoImovelFormComponent') enderecoImovelFormComponent: any;

    @Input() applicantDetails;
    @Input() subject;

    public listRequestAlvara = [
        alvaraFormEnum.SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA,
        alvaraFormEnum.SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA
    ];

    public subjectChangedOnce = false;
    public alvaraFormEnum = alvaraFormEnum;

    public requiredFieldsRequests = [
        'SOLAL_Nome',
        'SOLAL_CPF',
        'SOLAL_SubstitutoTributario',
        'SOLAL_Telefone',
        'SOLAL_Email',
        'SOLAL_UF',
        'SOLAL_Municipio',
        'SOLAL_Logradouro',
        'SOLAL_Numero',
        'SOLAL_Bairro',
        'SOLAL_CEP',
        'SOLAL_InicioAtividadeRFB',
        'SOLAL_AreaTotal',
        'SOLAL_ContabilNome',
        'SOLAL_ContabilCPFCNPJ',
        'SOLAL_ContabilCRC',
        'SOLAL_ResponsavelNome',
        'SOLAL_ResponsavelCPF',
        'SOLAL_ResponsavelQualificacao'
    ];

    constructor(
        public fb: FormBuilder,
        public fiscoService: FiscoService,
        private userDataRequestService: UserDataRequestService,
        private cnaeService: CnaeService,
    ) {
        super(fb, fiscoService);
    }

    ngOnInit(): void {
        this.initForm();
        this.formChanges();

        this.userDataRequestService.getRequerente().subscribe(requerente => {
            this.changeDataRequester(requerente);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.subject && this.subjectChangedOnce) {
            this.resetFormGroupsBySubject();
        } else {
            this.subjectChangedOnce = true;
        }
    }

    initForm() {
        this.renderForm();

        if (this.haveSubject([alvaraFormEnum.SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA])) {
            this.setValidatorsForm(this.requiredFieldsRequests);
        }

        if (this.haveSubject([alvaraFormEnum.SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA])) {
            this.setValidatorsForm([
                ...this.requiredFieldsRequests,
                'SOLAL_InicioAtividadeMunicipio'
            ]);
        }
    }

    renderForm() {
        this.form = this.fb.group({
            SOLAL_Nome: [''],
            SOLAL_CPF: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_SubstitutoTributario: ['NAO', Validators.required],
            SOLAL_InscricaoMunicipal: [''],
            SOLAL_Telefone: ['', [Validators.required, GenericValidator.isValidTelefone()]],
            SOLAL_Email: ['', [Validators.required, Validators.email]],
            SOLAL_InicioAtividadeMunicipio: [''],
            SOLAL_InicioAtividadeRFB: ['', Validators.required],
            
            SOLAL_UF: [''],
            SOLAL_Municipio: [''],
            SOLAL_Logradouro: [''],
            SOLAL_Numero: [''],
            SOLAL_Bairro: [''],
            SOLAL_Complemento: [''],
            SOLAL_CEP: [''],
            
            SOLAL_InscricaoIPTU: [''],
            SOLAL_AreaTotal: [null, Validators.required],
            
            SOLAL_ImovelUF: [''],
            SOLAL_ImovelMunicipio: [''],
            SOLAL_ImovelLogradouro: [''],
            SOLAL_ImovelNumero: [''],
            SOLAL_ImovelBairro: [''],
            SOLAL_ImovelComplemento: [''],
            SOLAL_ImovelCEP: [''],
            
            atividades: this.fb.array([
                this.createAtividade()
            ]),
            
            SOLAL_ContabilNome: ['', Validators.required],
            SOLAL_ContabilCPFCNPJ: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_ContabilCRC: ['', Validators.required],
            
            socios: this.fb.array([]),
            
            SOLAL_ResponsavelNome: ['', Validators.required],
            SOLAL_ResponsavelCPF: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_ResponsavelQualificacao: ['', Validators.required],
            
            formVariants: this.fb.group({
                SOL_Descricao: ['', Validators.required],
                termCheck: [false, Validators.requiredTrue]
            })
        });
    }

    private resetFormGroupsBySubject() {
        if (this.enderecoFormComponent) {
            this.enderecoFormComponent.reset();
        }
        if (this.enderecoImovelFormComponent) {
            this.enderecoImovelFormComponent.reset();
        }
        this.form.patchValue(this.fb.group({}));
        this.initForm();
        this.form.updateValueAndValidity();
        this.formChanges();
        this.changeDataRequester();
    }

    private setValidatorsForm(list: string[]) {
        for (const field of list) {
            const control = this.form.get(field);
            if (control) {
                control.setValidators(Validators.required);
                control.updateValueAndValidity();
            }
        }
    }

    getAddressAlvaratData(event) {
        this.form?.patchValue({
            SOLAL_Municipio: event.localidade,
            SOLAL_Bairro: event.bairro,
            SOLAL_Logradouro: event.logradouro,
            SOLAL_UF: event.uf,
            SOLAL_Numero: event.numero,
            SOLAL_Complemento: event.complemento,
            SOLAL_CEP: event.CEP
        });
        this.form.updateValueAndValidity();
    }

    getAddressImovelData(event) {
        this.form?.patchValue({
            SOLAL_ImovelMunicipio: event.localidade,
            SOLAL_ImovelBairro: event.bairro,
            SOLAL_ImovelLogradouro: event.logradouro,
            SOLAL_ImovelUF: event.uf,
            SOLAL_ImovelNumero: event.numero,
            SOLAL_ImovelComplemento: event.complemento,
            SOLAL_ImovelCEP: event.CEP
        });
        this.form.updateValueAndValidity();
    }

    get atividades() {
        return this.form.get('atividades') as FormArray;
    }

    get socios() {
        return this.form.get('socios') as FormArray;
    }

    createAtividade(): FormGroup {
        const atividade = this.fb.group({
            SOLAL_CNAE: ['',
                [
                    Validators.required,
                    Validators.maxLength(9),
                    Validators.pattern(/^[0-9]{9}$/)
                ]
            ],
            SOLAL_DescricaoAtividade: ['', Validators.required],
            SOLAL_EspecieContribuinte: ['', Validators.required],
            SOLAL_TipoTributacao: ['', Validators.required],
            cnaeList: []
        }, { validators: this.cnaeValidator });

        atividade.get('SOLAL_CNAE')?.valueChanges.subscribe((value) => {
            if (value && value.length >= 1) {
                this.cnaeService.searchCnae(value).subscribe((result: any[]) => {
                    atividade.get('cnaeList')?.setValue(result);
                });
            }
        });

        return atividade;
    }

    private cnaeValidator(group: FormGroup) {
        const numero = group.get('SOLAL_CNAE')?.value;
        const descricao = group.get('SOLAL_DescricaoAtividade')?.value;
    
        if (numero && descricao) {
            return null;
        }
    
        return { cnaeIncompleto: true };
    }

    limitCnaeLength(event: any, index: number) {
        const value = event.target.value.replace(/\D/g, '').slice(0, 9);
        this.atividades.at(index).get('SOLAL_CNAE')?.setValue(value, { emitEvent: false });
    }

    onSelectCnae(cnae, index: number) {
        const atividade = this.atividades.at(index);

        atividade.patchValue({
            SOLAL_CNAE: cnae.CNAE_Numero,
            SOLAL_DescricaoAtividade: cnae.CNAE_Descricao
        });
    }

    addAtividade(): void {
        this.atividades.push(this.createAtividade());
    }

    removeAtividade(index: number): void {
        if (this.atividades.length > 1) {
            this.atividades.removeAt(index);
        }
    }

    createSocio(): FormGroup {
        return this.fb.group({
            SOLAL_SocioCPFCNPJ: ['', [Validators.required, GenericValidator.isValidCpfOrCnpj()]],
            SOLAL_SocioNome: ['', Validators.required]
        });
    }

    addSocio(): void {
        this.socios.push(this.createSocio());
    }

    removeSocio(index: number): void {
        this.socios.removeAt(index);
    }

    public changeDataRequester(requerente?: any) {
        if (requerente) {
            this.form?.patchValue({
                SOLAL_CPF: requerente.SOLR_CpfCnpj,
                SOLAL_Nome: requerente.SOLR_NomeRazaoSocial,
                SOLAL_Email: requerente.SOLR_Email,
                SOLAL_Telefone: requerente.SOLR_Telefone
            });
    
            this.disabledFields(['SOLAL_CPF', 'SOLAL_Nome', 'SOLAL_Email', 'SOLAL_Telefone']);
        } else if (this.applicantDetails) {
            this.form?.patchValue({
                SOLAL_CPF: this.applicantDetails.SOLR_CpfCnpj,
                SOLAL_Nome: this.applicantDetails.SOLR_NomeRazaoSocial
            });
    
            this.disabledFields(['SOLAL_CPF', 'SOLAL_Nome']);
        }
    
        this.form.updateValueAndValidity();
    }

    public disabledFields(fields: string[]) {
        fields.forEach(field => {
            const control = this.form.get(field);
            if (control) {
                control.disable();
            }
        });
    }

    onSubstitutoChange(valor: 'SIM' | 'NAO') {
        this.form.get('SOLAL_SubstitutoTributario')?.setValue(valor);
    }
}